import type { SessionQueryParams } from 'models/internalApi';
import type { IntrospectionResponse } from 'utils/business-logic';
import { createUrl } from 'utils/url';

export async function requestSessionEndpoint({
	juridicalType,
	logout,
	marketCode,
}: SessionQueryParams) {
	const response = await fetch(
		createUrl('/api/signin/session/', { juridicalType, marketCode, logout }),
	);
	if (!response.ok) {
		throw new Error('requestSessionEndpoint failed');
	}
	const data = (await response.json()) as { tokenExpiry: number };
	return {
		statusCode: response.status,
		tokenData: {
			tokenExpiry: data.tokenExpiry,
		},
	};
}

export async function requestTokenData() {
	const response = await fetch('/api/token/introspection/');
	if (!response.ok) {
		throw new Error('requestTokenData failed');
	}
	if (response.status === 204) {
		return { statusCode: response.status };
	}
	const data = (await response.json()) as IntrospectionResponse;
	return {
		statusCode: response.status,
		tokenData: { ...data },
	};
}
